import { call, put } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';
import { interactionTriggered } from 'features/application/actions';

export function* muteAudioSaga() {
  yield put(interactionTriggered('muteAudio'));
  yield call(RTCClient.publishingFeed.stopAudioBroadcasting);
}
